import React from 'react'
import ListMyRaffles from '../../components/ListMyRaffles'

const Home = () => {
  return (<ListMyRaffles /> )
}

export default Home
